"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyClubRedirectAlert = void 0;
var legacyClubRedirectAlert_1 = require("./legacyClubRedirectAlert");
Object.defineProperty(exports, "LegacyClubRedirectAlert", { enumerable: true, get: function () { return __importDefault(legacyClubRedirectAlert_1).default; } });
